import isDeployed from './isDeployed';
import getHostName from './getHostname';
import { DEPLOYMENT_SLOT_SUFFIXES } from '../deploymentSlotSuffixes';
export const _private = {
    getHostName
};
export default function getEnvironment() {
    const hostname = _private.getHostName();
    if (!isDeployed(hostname)) {
        return 'local';
    }
    const path = hostname.split('.');
    const subdomain = stripRouteSuffix(path[0]);
    return subdomain.includes('app') ? 'prod' : subdomain;
}

const ROUTE_SUFFIX = new RegExp(`-(?:${DEPLOYMENT_SLOT_SUFFIXES.join('|')})$`);

function stripRouteSuffix(subdomain) {
    // Candidate and older "-green"/"-blue" URLs are alternate entry points for the same
    // environment. For example, staging-candidate.sstid.com should load staging config,
    // including the staging Auth0 app.
    return subdomain.replace(ROUTE_SUFFIX, '');
}
